<template>
  <div class="row dashboard_container recruiter_dashboard" aria-label="Recruiter Dashboard Page Content">

	  <div class="col-12 tfa-dashboard-section">

		  <div class="top-section row">

		    <div class="dashboard-row stream-section col-xl-8 col-lg-7 col-md-12 col-sm-12">
		      <div class="db_usr_lst_container">
		        <div class="card ace_sec" aria-level="1" aria-label="Prospective Students List Section" style="height: calc(100vh - 120px) !important;">
		          <div class="card-header">
                <span class="icon ic6-student"></span>
                <div class="more-link test-link">
                  <div class="search_field advisor-search-section">
            				<input placeholder="search by name" aria-label="search by name" v-model="name" v-on:keyup.enter="searchAdvisees()">
                    <b-btn class="left" @click="searchAdvisees()"><span class="fas fa-search" aria-label="search advisee"></span></b-btn>
            			</div>
                </div>
		          </div>

              <div class="card-body">
                <b-tabs>

                  <b-tab title="All Students" active>
                    <template v-if="advisees.length === 0">
                      <div class="no_data" v-if="isDataLoaded">No students found.</div>
                    </template>
    		            <div class="notifications-row lst_row" v-for="advisee in advisees">
                      <div class="message-creator-avatar usr_pic">
                        <span class="ic6-user1"></span>
                      </div>

                      <div class="row usr_details">

                        <div class="col-4 data_col">
                          <div tabindex="0" class="data_col_row1 stud_name" :aria-label="'Prospective Student ' + advisee.userName" :title="advisee.userName">{{ advisee.userName }}</div>
                          <div class="data_col_row2 stud_email" :title="advisee.userEmail">
                            <span class="ic ic6-mail3"></span> {{advisee.userEmail}}
                          </div>
                          <div class="data_col_row3">
                            <template v-if="advisee.userPhone" :title="advisee.userPhone">
                              <span class="ic ic6-phone" style="display: inline-block; width: 22px;"></span> {{advisee.userPhone}}
                            </template>
                            <template v-else>
                              <span class="ic ic6-phone" style="float: left; width: 22px; margin-right: 5px;"></span>
                              <span class="no_info">not filled in</span>
                            </template>
                          </div>
                        </div>

                        <div class="col-4 data_col">
                          <div class="data_col_row1">
                            <span class="ic ic6-degree"></span>
                            <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                                <span class="value" tabindex="0" :aria-label="'Major for student ' + advisee.userName + ' is ' + advisee.adviseeSharedStreams[0].majorTitle" :title="advisee.adviseeSharedStreams[0].majorTitle">{{ advisee.adviseeSharedStreams[0].majorTitle }}</span>
                            </template>
                            <template v-else>
                                <span class="no_info">- Undecided -</span>
                            </template>
                          </div>
                          <div class="data_col_row2">
                            <span class="ic ic-career"></span>
                            <span v-if="advisee.careerGoal" class="value career_goal" :title="advisee.careerGoal">{{advisee.careerGoal}}</span>
                            <span v-else class="no_info">not filled in</span>
                          </div>
                          <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].uuid">
                            <div class="data_col_row3">
                              <b-link class="view_report_lnk" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamReport', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                        				<span class="ic icon-activity"></span>
                        				<span class="title">view reports</span>
                        			</b-link>
                            </div>
                          </template>
                          <template v-else>
                            <div class="data_col_row3">
                              <b-link class="view_report_lnk" :to="{ name: 'userActivityReport', params: { uuid: 'abc', userId: advisee.userId }}" >
                                <span class="ic icon-activity"></span>
                                <span class="title">view reports</span>
                              </b-link>

                            </div>
                          </template>

                        </div>

                        <div class="col-4 date">
                          <div class="data_col_row1">
                            <template v-if="advisee.userRole">
                              <div class="usr_role_blc bg_purple float-right" :title="'Role: ' + advisee.userRole">{{ advisee.userRole.substring(0,1) }}</div>
                            </template>
                            <template v-if="advisee.userStatus">
                              <div class="float-right mr-5" :title="'Status: ' + advisee.userStatus">{{advisee.userStatus}}</div>
                            </template>
                          </div>
                          <div class="data_col_row2">
                            <template v-if="advisee.startDate">
                              <span v-if="advisee.userRole.substring(0,1) === 'P'">Inquiry Date:</span> <span v-if="advisee.userRole.substring(0,1) === 'A'">Acceptance Date:</span>  <span>{{ advisee.startDate }}</span>
                            </template>
                          </div>
                        </div>

                      </div>
    		            </div>

                  </b-tab>
                  <!-- All Students tab -->

                  <b-tab title="Prospective">
                    <div class="more-link test-link lnk_export">
                      <button title="export all prospective student as csv" tabindex="0" @click="exportProspectiveStudents()">export</button>
    		            </div>
                    <div class="notifications-row lst_row" v-for="advisee in prospectiveStudents">

                      <div class="message-creator-avatar usr_pic">
                        <span class="ic6-user1"></span>
                      </div>

                      <div class="row usr_details">

                        <div class="col-4">
                          <div class="data_col_row1">
                            <div tabindex="0" class="stud_name" :aria-label="'Prospective Student ' + advisee.userName" :title="advisee.userName">{{ advisee.userName }}</div>
                          </div>
                          <div class="data_col_row2 stud_email" :title="advisee.userEmail">
                            <span class="ic ic6-mail3"></span> {{advisee.userEmail}}
                          </div>
                          <div class="data_col_row3">
                            <template v-if="advisee.userPhone">
                              <span class="ic ic6-phone" :title="advisee.userPhone"></span> {{advisee.userPhone}}
                            </template>
                            <template v-else>
                              <span class="ic ic6-phone" style="float: left; margin-right: 10px;"></span> <span class="no_info">- Not added -</span>
                            </template>
                          </div>
                        </div>

                        <div class="col-4">
                          <div class="data_col_row1">
                            <span class="ic ic6-degree"></span>
                            <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                                <span class="value" tabindex="0" :aria-label="'Major for student ' + advisee.userName + ' is ' + advisee.adviseeSharedStreams[0].majorTitle" :title="advisee.adviseeSharedStreams[0].majorTitle">{{ advisee.adviseeSharedStreams[0].majorTitle }}</span>
                            </template>
                            <template v-else>
                                <span class="no_info">- Undecided -</span>
                            </template>
                          </div>
                          <div class="data_col_row2">
                            <span class="ic ic-career"></span>
                            <span v-if="advisee.careerGoal" class="value career_goal" :title="advisee.careerGoal">{{advisee.careerGoal}}</span>
                            <span v-else class="no_info">not filled in</span>
                          </div>
                          <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].uuid">
                            <div class="data_col_row3">
                              <b-link class="view_report_lnk" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamReport', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                        				<span class="ic icon-activity"></span>
                        				<span class="title">view reports</span>
                        			</b-link>
                            </div>
                          </template>
                          <template v-else>
                            <div class="data_col_row3">
                              <b-link class="view_report_lnk" :to="{ name: 'userActivityReport', params: { uuid: 'abc', userId: advisee.userId }}" >
                                <span class="ic icon-activity"></span>
                                <span class="title">view reports</span>
                              </b-link>

                            </div>
                          </template>
                        </div>

                        <div class="col-4 date">
                          <div class="data_col_row1">

                          </div>
                          <div class="data_col_row2">
                            <template v-if="advisee.startDate">
                              <span>Inquiry Date:</span> <span>{{ advisee.startDate }}</span>
                            </template>
                          </div>

                        </div>

                      </div>
                    </div>
                    <template v-if="prospectiveStudents.length === 0">
                      <div class="no_data">No prospective students found.</div>
                    </template>
                  </b-tab>
                  <!-- Prospective Students tab -->

                  <b-tab title="Admitted">
                    <div class="notifications-row lst_row" v-for="advisee in admittedStudents">

                      <div class="message-creator-avatar usr_pic">
                        <span class="ic6-user1"></span>
                      </div>

                      <div class="row usr_details">

                        <div class="col-4">
                          <div class="data_col_row1">
                            <div tabindex="0" class="stud_name" :aria-label="'Admitted Student ' + advisee.userName" :title="advisee.userName">{{ advisee.userName }}</div>
                          </div>
                          <div class="data_col_row2 stud_email" :title="advisee.userEmail">
                            <span class="ic6-mail3"></span> {{advisee.userEmail}}
                          </div>
                          <div class="data_col_row2 stud_email" :title="advisee.userPhone" v-if="advisee.userPhone">
                            <span class="ic6-mail3"></span> {{advisee.userPhone}}
                          </div>
                        </div>

                        <div class="col-4">
                          <span class="ic ic6-degree"></span>
                          <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                              <span class="value" tabindex="0" :aria-label="'Major for student ' + advisee.userName + ' is ' + advisee.adviseeSharedStreams[0].majorTitle" :title="advisee.adviseeSharedStreams[0].majorTitle">{{ advisee.adviseeSharedStreams[0].majorTitle }}</span>
                          </template>
                          <template v-else>
                              <span class="no_info">- Undecided -</span>
                          </template>
                          <div class="data_col_row2">
                            <span class="ic ic-career"></span>
                            <span v-if="advisee.careerGoal" class="value career_goal" :title="advisee.careerGoal">{{advisee.careerGoal}}</span>
                            <span v-else class="no_info">not filled in</span>
                          </div>
                          <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].uuid">
                            <div class="data_col_row3">
                              <b-link class="view_report_lnk" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamReport', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                        				<span class="ic icon-activity"></span>
                        				<span class="title">view reports</span>
                        			</b-link>
                            </div>
                          </template>
                          <template v-else>
                            <div class="data_col_row3">
                              <b-link class="view_report_lnk" :to="{ name: 'userActivityReport', params: { uuid: 'abc', userId: advisee.userId }}" >
                                <span class="ic icon-activity"></span>
                                <span class="title">view reports</span>
                              </b-link>
                            </div>
                          </template>

                        </div>

                        <div class="col-4 date">
                          <div class="data_col_row1">
                            <template v-if="advisee.userRole">
                              <div class="usr_role_blc bg_purple" :title="'Role: ' + advisee.userRole">{{ advisee.userRole.substring(0,1) }}</div>
                            </template>
                          </div>
                          <div class="data_col_row2">
                            <template v-if="advisee.startDate">
                              <span>Acceptance Date:</span> <span>{{ advisee.startDate }}</span>
                            </template>
                          </div>
                        </div>

                      </div>
                    </div>
                    <template v-if="admittedStudents.length === 0">
                      <div class="no_data">No admitted students found.</div>
                    </template>
                  </b-tab>
                  <!-- Admitted Students tab -->

                </b-tabs>
                <!-- b-tabs -->

                <div class="loading-spinner">
                  <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc hide-backdrop size="sm">
                    <div class="text-center" style="color: #787878; overflow: hidden;">
                      <div><i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i></div>
                    </div>
                  </b-modal>
                </div>

              </div>

		        </div>
		      </div>
		    </div>

		    <div class="dashboard-row stream-section col-xl-4 col-lg-5 col-md-12 col-sm-12 db_rgt_panel reports">
              <div class="rgt_pan">
                <div class="card ace_sec" aria-level="2" aria-label="Activity Section" style="height: calc(100vh - 120px) !important;">
                  <div class="card-header">
                    <span class="icon icon-activity" style="margin-top: -3px; margin-left: -2px;"></span>
                    <span class="label ace_sec_hd" role="heading" aria-label="Activity" style="width: 110px;">Activity</span>
                    <b-link class="hd_lnk" @click="navigateToReports()" style="margin-top: 5px;">more</b-link>
                  </div>
                  <div class="card-body">
                    <template v-for="c in dashboardReports">
                      <div class="row report_sec_block" @click="navigateToReports()">
                        <div class="col-12 hd ace_sec_hd" :aria-label="c.title">
            							<span>{{c.title}}</span>
            						</div>
                      	<div class="col-12">
                          <report :selectedReport="c" :type="c.visualizationType" :timeperiod="'60'"></report>
                        </div>
                      </div>
                    </template>
                    <template v-if="dashboardReports.length == 0">
                      <div class="row">
                        <div class="col-12">
                          <dummy-graph ref="DummyGraph"></dummy-graph>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--
            <div class="dashboard-row notifications-panel col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div class="">
                <div class="card ace_sec" aria-level="3" aria-label="Message Section">
                  <div class="card-header">
                    <span class="icon icon-bell"></span>
                    <span class="label ace_sec_hd" role="heading" aria-label="Messages">Messages</span>
                  </div>
                  <div class="card-body notification-content-section">
                    <div class="notifications-row" v-for="message in messages" style="cursor: default;">
                      <div class="message-creator-avatar"><span class="icon-user"></span></div>
                      <div class="msg-section">
                        <div class="user-row" tabindex="0" :aria-label="message.name + ' add a message on ' + message.date">
                          <span class="user-name-section">{{ message.name }}</span>
                          <span class="time-section">{{ message.date }}</span>
                        </div>
                        <div class="msg-row" tabindex="0" style="white-space: normal;" :aria-label="message.name + ' message is ' + message.text">
                          {{ message.text }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            -->
		  </div>
	  </div>

  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import DummyGraph from './dummyGraph'
  import { db } from '../../../firebase'
  import Report from '../../institution/components/Report'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'recruiter-dashboard',
    components: {
      DummyGraph,
      Report
    },
    props: [],
    data: () => {
      return {
        name: '',
        messages: [],
        currentChannel: '',
        report: '',
        userReports: [],
        isDataLoaded: false
      }
    },

    mounted () {
      const institutionId = localStorage.getItem('institutionId')
      this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
        if (this.isNewRecruiterDashboardEnabled) {
          return this.$router.push({ name: 'adviseeTracker' })
        } else {
          this.loadRecruiterDashboard()
        }
      })
    },

    created () {
      this.currentChannel = this.userObj.externalId
      this.$watch('currentChannel', (externalId) => {
        if (externalId) {
          this.$bindAsArray('messages', db.ref('channels/' + externalId + '/Messages'))
        }
      }, {
        immediate: true
      })
    },

    firebase: {
      messages: {
        source: db.ref('channels/' + this.currentChannel + '/Messages'),
        readyCallback: function () {
        },
        cancelCallback: function (e) {
          console.log('Could not get messages', e)
        }
      }
    },

    watch: {
      messages () {
        setTimeout(() => {
          var msgSectionHeight = $('.msg_section_inner_recommendation').innerHeight()
          $('.msg_row_section_recommendation').scrollTop(msgSectionHeight)
          var msgSectionHeight2 = $('.msg_section_inner_urgent').innerHeight()
          $('.msg_row_section_urgent').scrollTop(msgSectionHeight2)
        }, 100)
      },
      name (newName) {
        if (newName.length === 0) {
          this.searchAdvisees()
        }
      }
    },

    methods: {
      ...mapActions([
        'loadAdvisees',
        'loadUpdatePageCount',
        'exportProspectiveStudentsToCsv',
        'loadRecruiterReport',
        'loadUserReports',
        'loadInstitutionPackage'
      ]),

      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      navigateToReports () {
        $('.icon-home').removeClass('active')
        return this.$router.push({ name: 'recruiterReport' })
      },

      async loadRecruiterDashboard () {
        this.showLoader()
        this.loadUpdatePageCount({page: 0, count: 10000})
        this.loadAdvisees({name: this.name, sort: 'creationTime'}).then(resp => {
          this.hideLoader()
          this.isDataLoaded = true
        })
        // this.report = await this.loadRecruiterReport()
        this.userReports = await this.loadUserReports()
      },

      async searchAdvisees () {
        this.loadUpdatePageCount({page: 0, count: 10000})
        await this.loadAdvisees({name: this.name, sort: 'creationTime'})
      },

      navigateToTracker () {
        this.loadUpdatePageCount({page: 0, count: 100})
        return this.$router.push({ name: 'prospectiveStudentTracker', params: {isProspectiveStudent: true} })
      },

      writeFile (data) {
        const blob = new Blob([data], {type: 'text/plain'})
        const e = document.createEvent('MouseEvents')
        let a = document.createElement('a')
        a.download = 'prospective_students.csv'
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
      },
      exportProspectiveStudents () {
        this.exportProspectiveStudentsToCsv().then(response => {
          let summaryCsvFile = response && response.fileContents ? response.fileContents : response
          let errors = response && response.error ? response.error : ''
          let warnings = response && response.warning ? response.warning : ''
          if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
            return this.notifyFailure(errors)
          }
          this.writeFile(summaryCsvFile)
          if (warnings && warnings.length > 0) {
            this.notifyWarning(warnings)
          } else {
            this.notifySuccess('Prospective Students Successfully Exported to Csv')
          }
        })
      }
    },

    computed: {
      ...mapState({
        'userObj': state => state.user.userObj,
        'advisees': state => state.adviseeTracker.advisees,
        'total': state => state.adviseeTracker.total,
        'count': state => state.adviseeTracker.count,
        'page': state => state.adviseeTracker.page,
        'enabledFeatures': state => state.institution.enabledFeatures,
      }),
      isNewRecruiterDashboardEnabled () {
        let newRecruiterDashboardFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_NEW_RECRUITER_DASHBOARD]
        if (newRecruiterDashboardFeature) {
          return newRecruiterDashboardFeature.isEnabled
        }
        return false
      },
      admittedStudents () {
        if (this.advisees.length > 0) {
          let aStudents = []
          this.advisees.forEach((advisee) => {
            if (advisee.userRole === 'Admitted Student') {
              aStudents.push(advisee)
            }
          })
          return aStudents
        }
        return []
      },
      prospectiveStudents () {
        if (this.advisees.length > 0) {
          let pStudents = []
          this.advisees.forEach((advisee) => {
            if (advisee.userRole === 'Prospective Student') {
              pStudents.push(advisee)
            }
          })
          return pStudents
        }
        return []
      },
      dashboardReports () {
        if (this.userReports.length > 0) {
          let dashboardReports = []
          this.userReports.forEach((item, i) => {
            if (item.showOnDashboard) {
              dashboardReports.push(item)
            }
          })
          return dashboardReports
        } else {
          return []
        }
      }
    }
  }
</script>

<style scoped>
    .card {
        height: calc(100vh - 200px) !important;
    }
    .card-body {
        overflow: auto !important;
    }
    .icon-activity {
        font-size: 45px !important;
    }
    .report_iframe {
      border: none;
    }
    .icon-home {
      color: rgb(200, 200, 200) !important;
    }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/RecruiterDashboard.vue